<script setup>

import CardGame from "@/Components/CardGame.vue";
import {Link} from "@inertiajs/vue3";
import {route} from "ziggy-js";
import SearchResultEmpty from "@/Components/SearchResultEmpty.vue";

const props = defineProps({
    searchResult: {
        type: Array,
        default: []
    },
    loading: {
        type: Boolean,
        default: false
    },
    search: {
        type: String,
        default: ''
    },
})

</script>

<template>
    <transition
        enter-active-class="ease-out duration-300"
        enter-from-class="opacity-0"
        enter-to-class="opacity-100"
        leave-active-class="ease-in duration-200"
        leave-from-class="opacity-100"
        leave-to-class="opacity-0"
    >
        <div class="flex absolute w-full z-30 top-[104%]">
            <div
                class="bg-white dark:bg-dark-blue relative w-full border-2 border-gray-100 grid grid-cols-1 rounded-lg shadow-[0_2px_6px_-15px_rgba(0,0,0,0.3)] pb-3">
                <div class="px-2.5">
                    <div class="dark:text-slate-200 px-3.5 py-2.5 text-xs font-bold leading-full">{{ $t('Related results') }}:</div>
                </div>

                <!--            v-transition:enter="transition ease-out duration-300"-->
                <!--            v-transition:enter-start="opacity-0 translate"-->
                <!--            v-transition:enter-end="opacity-100 translate"-->
                <!--            v-transition:leave="transition ease-in duration-300"-->
                <!--            v-transition:leave-start="opacity-100 translate"-->
                <!--            v-transition:leave-end="opacity-0 translate"  class="w-1/2">-->
                <template v-if="searchResult.length > 0">
                    <template v-for="item in searchResult" :key="item">
                        <CardGame :mini-img="true"
                                  :hover="true"
                                  class="[&:nth-child(-n+5)]:flex lg:[&:nth-child(-n+8)]:flex hidden w-full grow !pr-2.5" :product="item"/>
                    </template>
                    <div class="px-2.5 pt-2.5">
                        <Link :href="route('products.index', {search: props.search})"
                              method="get"
                              class="grow flex items-center justify-center rounded-lg w-full h-10 dark:text-slate-200 transition-colors text-sm font-normal bg-slate-200 dark:bg-slate-600">
                            <span>{{ $t('Show all') }}</span>
                        </Link>
                    </div>

                </template>
                <template v-else>
                    <SearchResultEmpty/>
                </template>
            </div>
        </div>
    </transition>
</template>

<style scoped>

</style>
